"use client";

import { useEffect } from "react";
import { clearChunkReloadFlag, reloadOnceForChunkError } from "@/lib/chunk-reload";

const SUCCESSFUL_LOAD_MS = 10_000;

export function ChunkReloadListener() {
  useEffect(() => {
    const clearTimer = setTimeout(clearChunkReloadFlag, SUCCESSFUL_LOAD_MS);

    function onError(event: ErrorEvent) {
      reloadOnceForChunkError(event.error ?? event.message);
    }
    function onRejection(event: PromiseRejectionEvent) {
      reloadOnceForChunkError(event.reason);
    }

    window.addEventListener("error", onError);
    window.addEventListener("unhandledrejection", onRejection);

    return () => {
      clearTimeout(clearTimer);
      window.removeEventListener("error", onError);
      window.removeEventListener("unhandledrejection", onRejection);
    };
  }, []);

  return null;
}
